import { roboneoApi } from '$/api/request';
import APP from '$/api/api';
import {
  GetRecordListOptions,
  GetRecordListReqType,
  RecordCategoryType,
} from './type';

/** 读取项目记录；个人项目导入场景可显式跳过当前团队 Client-OID。 */
export async function getRecordList(
  data?: GetRecordListReqType,
  options: GetRecordListOptions = {},
) {
  try {
    const response = await roboneoApi.request({
      url: APP.roboneo.api.path,
      method: 'POST',
      skipClientOId: options.scope === 'personal',
      data: {
        parameter: {
          // app_scene: 'roboneo',
          path_scene: 'historylist',
          features: '',
          later_face: 0,
          ...data,
        },
      },
    });
    return {
      list: (response.data.parameter.list || []) as Array<RecordCategoryType>,
      bottomDesc: response.data.parameter.bottom_desc || '',
      totalCount: response.data.parameter.total_count || 0,
    };
  } catch (error) {
    console.error('Proxy Test Error:', error);
    throw error;
  }
}

export async function recordDelete(data: { roomId: string; }) {
  try {
    const response = await roboneoApi.request({
      url: APP.roboneo.api.path,
      method: 'POST',
      data: {
        parameter: {
          // app_scene: 'roboneo',
          path_scene: 'historydel',
          features: '',
          later_face: 0,
          room_id: data.roomId,
        },
      },
    });
    return response.data;
  } catch (error) {
    console.error('Proxy Test Error:', error);
    throw error;
  }
}
